import { isMobile } from 'react-device-detect'
import { createAppFromCommonTemplate, lazyImport } from '@helpers'
import { productMedia } from '@velasca/utils/globals'
import { transformProductMedia } from '@velasca/utils/transform-product-media'

const { MediaCarousel } = lazyImport(
  () => import('@velasca/ui/media-carousel'),
  'MediaCarousel',
)

const productImagesEl = document.getElementById('product-images')

export const renderMediaCarouselApp = () => {
  if (productMedia) {
    createAppFromCommonTemplate(
      productImagesEl,
      <MediaCarousel
        buttonColor="white"
        media={transformProductMedia(productMedia as any, isMobile)}
        hasZoom={
          document
            .getElementById('product-images')
            ?.getAttribute('data-zoom') !== 'false'
        }
      />,
    )
  }
}
